// Shared unresolved cloud column for the globe and the close-view pass.
// All quantities are linear RGB. Lighting depends on the cloud's position,
// never on the camera's subsolar angle or the chosen rendering distance.
export const EARTH_CLOUD_COLUMN_GLSL = /* glsl */`
float earthCloudColumnAlpha(float column, float viewMu) {
  float path = 1.0 / max(abs(viewMu), 0.08);
  return 1.0 - exp(-3.2 * max(column - 0.015, 0.0) * path);
}

vec3 earthCloudColumnLight(float sunMu, float viewMu) {
  // Cloud tops lose incident energy as the sun approaches the horizon.
  // A constant direct-light floor produced a broad luminous orange belt.
  // A finite solar/twilight shoulder avoids the infinite slope of
  // sqrt(max(sunMu,0)) exactly at the terminator.
  float mu = clamp(0.5 * (sunMu + sqrt(sunMu * sunMu + 0.0004)), 0.0, 1.0);
  float airMass = 1.0 / sqrt(mu * mu + 0.025 * 0.025);
  vec3 transmission = exp(-vec3(0.035, 0.083, 0.200) * (airMass - 1.0));
  vec3 direct = vec3(0.94) * sqrt(mu) * transmission * smoothstep(-0.04, 0.01, sunMu);
  float day = smoothstep(-0.10, 0.22, sunMu);
  vec3 sky = vec3(0.035, 0.045, 0.065) * day + vec3(0.002, 0.003, 0.005);
  // The close-view composite runs after the globe's atmosphere. Include
  // cloud-top aerial perspective here so it cannot paint over the blue limb.
  float aerial = pow(1.0 - clamp(abs(viewMu), 0.0, 1.0), 2.5);
  return direct + sky + vec3(0.62, 0.78, 0.95) * aerial * 0.6 * day;
}

float earthCloudFallbackAlpha(float alpha, float volumeBlend) {
  // The close layer is composited over this layer: A = Av + Af*(1-Av).
  // Complementary raw weights would make clouds fade halfway through zoom.
  return alpha * (1.0 - volumeBlend) / max(1.0 - alpha * volumeBlend, 0.001);
}
`;
